// extracted by mini-css-extract-plugin
module.exports = {"toggle":"ToggleButton_toggle__2fHya","toggleIcon":"ToggleButton_toggleIcon__2u9qJ","arrowDown":"ToggleButton_arrowDown__pAezi"};